export default "__VITE_ASSET__d5TgwYg8__"